module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_c('help-popover', [_vm._v("\n        This is a list of clients that you've seen within the\n        selected daterange\n      ")]), _vm._v("\n      Active clients\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.withSearch) ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "prepend-icon": "search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.filteredActiveClients), function(relationship, index) {
    return [_c('v-list-tile', {
      key: relationship.id,
      class: {
        "blue lighten-5": (_vm.activeIndex === index)
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(relationship, index)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(relationship.client.first_name) + " " + _vm._s(relationship.client.last_name) + "\n        ")])], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (relationship.id))
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bbdfdd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ActiveClients.vue
// module id = 1311
// module chunks = 9